import { blogImageLoader } from '@/lib/entities/blog';

import { clsx } from 'clsx';
import Image from 'next/image';

import styles from './BlogCover.module.scss';

type BlogCoverProps = {
  imageUrl: string | null;
  className?: string;
  sizes: string;
  priority?: boolean;
};

export const BlogCover = ({
  imageUrl,
  className,
  sizes,
  priority = false,
}: BlogCoverProps) => {
  if (!imageUrl) {
    return (
      <div className={clsx(styles.cover, className)}>
        <div className={styles.cover__placeholder} />
      </div>
    );
  }

  return (
    <div className={clsx(styles.cover, className)}>
      <Image
        src={imageUrl}
        alt=""
        fill
        sizes={sizes}
        className={styles.cover__image}
        style={{ objectFit: 'cover' }}
        loader={blogImageLoader}
        priority={priority}
      />
    </div>
  );
};
